import request from '@/utils/request';

/*  分页列表   */
export function getTablePage(data) {
    return request({
        url: '/dysx/partnership/page',
        method: 'get',
        params: data
    })
}

